"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./LogoutCallback.scss");
var LogoutCallback = function (props) {
    var authService = props.authService, applicationLogo = props.applicationLogo, applicationName = props.applicationName, children = props.children, logoutMessage = props.logoutMessage;
    react_1.useEffect(function () {
        authService.logout();
    }, []);
    return children ? (react_1.default.createElement(react_1.default.Fragment, null, children)) : (react_1.default.createElement("div", { className: "logoutPage" },
        react_1.default.createElement("img", { src: applicationLogo, alt: "Application logo" }),
        react_1.default.createElement("h1", null, applicationName),
        react_1.default.createElement("h2", null, logoutMessage)));
};
exports.default = LogoutCallback;
//# sourceMappingURL=LogoutCallback.js.map